export default "__VITE_ASSET__2cdc4b15__"